import React from 'react';
import { classNames } from 'primereact/utils';

export const FormRow = ({
  label,
  htmlFor,
  required = false,
  labelCol = 'col-12 md:col-2',
  inputCol = 'col',
  children,
  className,
  noMargin = false,
}) => {
  return (
    <div
      className={classNames(
        'field grid align-items-center cm-form-row',
        noMargin && 'mb-0',
        className
      )}
    >
      <div className={classNames(labelCol, 'cm-form-row-label')}>
        <label htmlFor={htmlFor}>
          {required && <i className="text-red-400 pi pi-check mr-1" aria-hidden />}
          {label}
        </label>
      </div>
      <div className={classNames(inputCol, 'cm-form-row-control')}>{children}</div>
    </div>
  );
};
